<template>
  <div>
    <div class="bullshit__oops">OOPS!</div>
    <div class="bullshit__headline">子应用加载错误</div>
    <div class="bullshit__info">请检查主应用中singleSpa.js里的appInfos的路径是否错误</div>
  </div>
</template>

<script>
export default {
  name: 'portalErrorApp'
}
</script>



// WEBPACK FOOTER //
// src/js/module/layout/_source/errorApp.vue